import React from 'react';
import { Switch, Redirect } from 'react-router-dom';

import { RouteWithLayout } from './components';
import { Main as MainLayout } from './layouts';

import {
  Info as InfoView,
} from './views';

const Routes = () => {
  return (
    <Switch>
      <Redirect
        exact
        from="/"
        to="/info"
      />
      <RouteWithLayout
        component={InfoView}
        exact
        layout={MainLayout}
        path="/info"
      />
      <RouteWithLayout
        component={InfoView}
        exact
        layout={MainLayout}
        path="/info/:token"
      />
      <Redirect to="/info" />
    </Switch>
  );
};

export default Routes;
